import { Reveal } from './Reveal.tsx';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function TrustLogos({ config }: { config: SiteConfig }) {
  const logos = config.trustLogos.logos.filter((l) => l.visible).sort((a, b) => a.order - b.order);
  if (logos.length === 0) return null;

  return (
    <section style={{ padding: '32px 24px', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal>
        <div style={{ textAlign: 'center', fontSize: 12.5, fontWeight: 700, color: 'var(--text-tertiary)', marginBottom: 20 }}>
          {config.trustLogos.title}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 28 }}>
          {logos.map((logo) => (
            <div
              key={logo.name}
              style={{
                width: 130,
                height: 44,
                borderRadius: 10,
                background: 'var(--surface)',
                border: '1px dashed var(--border)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'var(--text-tertiary)',
                fontSize: 11.5,
                fontWeight: 700,
              }}
              title="Logo de démonstration"
            >
              {logo.imageUrl ? <img src={logo.imageUrl} alt={logo.name} style={{ maxHeight: '70%', maxWidth: '80%' }} /> : logo.name}
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
